export default __webpack_public_path__ + "static/media/about-team-join.1116d2e0.png";